module.exports = __webpack_public_path__ + "img/icon_Market-Access.0eb7cb16.svg";